import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b59a7e0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "logo-overlay",
    style: { top: _ctx.CTAVisible && !_ctx.showEndedPage ? '45px !important' : '' }
  }, [
    _createVNode("img", {
      class: _ctx.comClass,
      src: _ctx.logoUrl,
      alt: "brand logo"
    }, null, 10, ["src"])
  ], 4))
})